export const U_API = "http://sap:105/getData.php";
export const U_API2 = "http://sap:107/service/";

export const siteId = "www.eluniversal.com.mx";
export const segmentId = "1";

export const API_USUARIOS = "https://fnd60601lk.execute-api.us-east-1.amazonaws.com/usuarios/site/" + siteId;
export const API_USUARIO = "https://fnd60601lk.execute-api.us-east-1.amazonaws.com/usuario/uid/";

export const API_NewslettersList = "https://tfej9bgk64.execute-api.us-east-1.amazonaws.com/newsletters/site/" + siteId;
export const API_NewslettersNew = "https://tfej9bgk64.execute-api.us-east-1.amazonaws.com/newsletters/nuevonewsletter/" + siteId + "/" + segmentId;
export const API_Emarsys = "https://tfej9bgk64.execute-api.us-east-1.amazonaws.com/newsletters/inscampaign/" + siteId;

export const IframeHomeUrl = "https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/095464311798/dashboards/eeb7c938-d8f9-49e3-83b7-f9ae24d40ac2?directory_alias=eluniversal"

/*Contenido recomendado*/

export const cr_codeIframeHtml = '<iframe ' +
    'src="https://recomendacion.audiencias-api.com/?siteid=' + siteId +  ' ' +
    'width="100%" ' +
    'height="600" ' + 
    'frameBorder="0" ' +
    '"title="Audiencias"> ' +
    '</iframe> ';

export const cr_codeIframe = ` <div id="audiencias-iframe"></div>
  <script>
    document.addEventListener('DOMContentLoaded', () => {
      if (typeof xaud !== 'undefined' && xaud.getPPId) {
        const iframe = document.createElement('iframe');
        iframe.src = \`https://recomendacion.audiencias-api.com/?uid=\${xaud.getPPId()}\`;
        iframe.style = "width:100%;height:600px;border:0";
        document.getElementById('audiencias-iframe').appendChild(iframe);
      }
    });
  </script>
`;

export const cr_codeHTML = `  <div class="nc-container">
    <div class="nc-wrapper">
      <div class="nc-ad">
        <img src="https://www.ceupe.com/images/easyblog_articles/3406/b2ap3_large_publicidad.png" alt="Publicidad" />
      </div>
      <div class="nc-carousel-wrapper">
        <button class="nc-nav-btn left" id="nc-prev">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
            <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path>
          </svg>
        </button>
        <div class="nc-carousel" id="nc-carousel"></div>
        <button class="nc-nav-btn right" id="nc-next">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
            <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>`;

export const cr_codeCSS = ` .nc-container {
      font-family: "Work Sans", sans-serif;
      max-width: 900px;
      margin: auto;
    }
    .nc-wrapper {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      padding: 10px;
    }
    .nc-ad {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .nc-ad img {
      width: 300px;
      height: 250px;
      object-fit: contain;
      border: 1px dashed #ddd;
    }
    .nc-carousel-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      overflow: hidden;
      padding: 0 10px;
    }
    .nc-carousel {
      display: flex;
      overflow-x: auto;
      scroll-behavior: smooth;
      gap: 10px;
      scrollbar-width: none;
      scroll-snap-type: x mandatory;
    }
    .nc-carousel::-webkit-scrollbar {
      display: none;
    }
    .nc-item {
      min-width: 208px;
      height: 270px;
      background-color: #fff;
      border-radius: 4px;
      scroll-snap-align: start;
      opacity: 0;
      transform: translateY(10px);
      animation: nc-fadeInUp 0.4s ease forwards;
      animation-delay: calc(0.05s * var(--i));
      text-decoration: none;
      color: inherit;
      border: 1px solid transparent;
      transition: border 0.3s, background 0.3s;
    }
    .nc-item:hover {
      border: 1px solid #c5e7fd;
      background-color: rgba(193, 224, 243, 0.25);
    }
    @keyframes nc-fadeInUp {
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    .nc-img {
      width: 100%;
      height: 137px;
      object-fit: cover;
      border-radius: 4px;
      pointer-events: none;
    }
    .nc-text {
      padding: 0 10px;
      font-size: 14px;
      margin: 10px 0 5px;
      line-height: 1.2em;
      min-height: 3.6em;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .nc-comment {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 13px;
      color: #333;
      padding: 10px 10px;
    }    
    .nc-nav-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 1;
    }
    .nc-nav-btn.left {
      left: 5px;
    }
    .nc-nav-btn.right {
      right: 5px;
    }
    .nc-nav-btn:hover {
      background: #f0f0f0;
    }
    @media (max-width: 768px) {
      .nc-wrapper {
        flex-direction: column;
        align-items: center;
      }
      .nc-ad {
        margin-top: 15px;
      }
    }`;

export const cr_codeJS = `document.addEventListener('DOMContentLoaded', () => {      
  const carousel = document.getElementById('nc-carousel');

  async function cargarNoticias() {
    try {
      if (typeof xaud !== 'undefined') {
        const uid  = xaud.getPPId();
        const apiUrl = "https://zv8rgrvdla.execute-api.us-east-1.amazonaws.com/usuarios-recomendacion/usuario/" + uid;
        const res = await fetch(apiUrl);
        if (!res.ok) throw new Error('Error al cargar noticias');
        const noticias = await res.json();
        
        carousel.innerHTML = '';

        noticias?.articulos?.forEach((item, index) => {
          const a = document.createElement('a');
          a.href = item.url;
          a.className = 'nc-item';
          a.style.setProperty('--i', index);

          const img = document.createElement('img');
          img.src = item.img;
          img.alt = item.text;
          img.className = 'nc-img';

          const texto = document.createElement('p');
          texto.className = 'nc-text';
          texto.textContent = item.text;

          const comentario = document.createElement('div');
          comentario.className = 'nc-comment';

          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('stroke', 'currentColor');
          svg.setAttribute('fill', 'currentColor');
          svg.setAttribute('stroke-width', '0');
          svg.setAttribute('viewBox', '0 0 512 512');
          svg.setAttribute('height', '1em');
          svg.setAttribute('width', '1em');

          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z');
          svg.appendChild(path);
          comentario.appendChild(svg);

          const span = document.createElement('span');
          span.textContent = item.comments + " comentarios";
          comentario.appendChild(span);

          a.append(img, texto, comentario);
          carousel.appendChild(a);
        });
      }
      else{
        console.error("Objeto xaud no esta definido");
        throw new Error("Objeto xaud no esta definido");
      }

    } catch (error) {
      console.error(error);
    }
  }

  cargarNoticias();
  
  document.getElementById('nc-prev').addEventListener('click', () => {
    carousel.scrollBy({ left: -carousel.offsetWidth, behavior: 'smooth' });
  });

  document.getElementById('nc-next').addEventListener('click', () => {
    carousel.scrollBy({ left: carousel.offsetWidth, behavior: 'smooth' });
  });

  let isDragging = false, startX, scrollStart;

  carousel.addEventListener('mousedown', e => {
    isDragging = true;
    startX = e.pageX;
    scrollStart = carousel.scrollLeft;
  });

  carousel.addEventListener('mouseup', () => isDragging = false);
  carousel.addEventListener('mouseleave', () => isDragging = false);

  carousel.addEventListener('mousemove', e => {
    if (!isDragging) return;
    e.preventDefault();
    const walk = (e.pageX - startX) * 2;
    carousel.scrollLeft = scrollStart - walk;
  });
});`;




export const au_htmlpage = `
<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>Playlist Notas audio De10</title>
    <!-- Google Fonts – Montserrat -->
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap" rel="stylesheet">

    <style>
        /* ----------  Reset & helpers  ---------- */
        *,
        *::before,
        *::after {
            box-sizing: border-box;
            margin: 0;
            padding: 0
        }

        body {
            font-family: 'Montserrat', sans-serif;
            background: #f5f5f5;
            display: flex;
            justify-content: center;
            padding: 24px 0;
            color: #111;
        }

        a {
            color: inherit;
            text-decoration: none
        }

        /* ----------  Widget  ---------- */
        .news-widget {
            width: 100%;
            max-width: 300px;
            background: #fff;
            /* fondo blanco fijo */
            overflow: hidden;
            box-shadow: 0 3px 10px rgba(0, 0, 0, .06);
        }

        /* ----------  Encabezado  ---------- */
        .news-widget h2 {
            font-size: 1rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: .05em;
            text-align: center;
            padding: 18px 0 14px;
            position: relative;
            color: #000;
        }

        .news-widget h2::after {
            /* franja naranja bajo el título */
            content: '';
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            width: 300px;
            height: 4px;
            background: #ea552d;
            /* naranja corporativo */
            border-radius: 2px 2px 0 0;
        }

        @media(max-width:400px) {
            body {
                padding: 24px 10px
            }
        }

        /* ----------  Hero  ---------- */
        .hero {
            width: 100%;
            height: fit-content;
            object-fit: cover
        }

        /* ----------  Playlist  ---------- */
        .playlist {
            background: #eee;
            padding: 16px
        }

        .playlist h3 {
            font-size: .95rem;
            font-weight: 600;
            margin-bottom: 8px;
            color: #ea552d;
            /* naranja de10 */
        }

        .playlist p {
            font-size: .85rem;
            line-height: 1.4;
            color: #555
        }

        .share {
            display: flex;
            gap: 16px;
            margin-top: 16px;
            justify-content: flex-end;
        }

        .share a {
            background: #fff;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .share svg {
            width: 16px;
            height: 16px
        }

        /* ----------  Lista de audios ---------- */
        .audio-list {
            list-style: none
        }

        .audio-item {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 12px 5px 12px 12px;
            border-top: 1px solid #ccc;
            /* línea tenue naranja */
        }

        .audio-item:first-child {
            padding: 12px 5px 12px 12px;
        }

        .thumb {
            flex: 0 0 48px
        }

        .thumb img {
            width: 48px;
            height: 48px;
            border-radius: 4px;
            object-fit: cover
        }

        .info {
            flex: 1;
            min-width: 0
        }

        .title {
            font-size: .9rem;
            font-weight: 600;
            white-space: break-spaces;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        .details {
            font-size: .75rem;
            color: #767676
        }

        button.play {
            flex: 0 0 34px;
            background: none;
            border: none;
            cursor: pointer;
            padding: 0
        }

        button.play svg {
            width: 20px;
            height: 20px;
            fill: #ea552d
        }

        button.play:hover svg {
            fill: #ff724b
        }

        /* ----------  Text-selection colors (detalle de marca) ---------- */
        ::selection {
            background: #ea552d;
            color: #fff
        }
    </style>
</head>

<body>

    <article class="news-widget">

        <h2>Noticias del Día</h2>

        <!-- Imagen destacada -->
        <img class="hero" src="/assets/img/anuncion.png" width="300" height="100%" alt="Imagen destacada">

        <!-- Playlist patrocinada -->
        <section class="playlist">
            <h3>Playlist Noticias del día</h3>
            <p>Mantente informado con nuestros audios de las notas del día </p>

            <div class="share">
                <a href="#" title="Compartir en Facebook" aria-label="Facebook">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path
                            d="M22 12.07C22 6.53 17.52 2 12 2S2 6.53 2 12.07c0 5.02 3.67 9.18 8.44 9.93v-7.03H7.9v-2.9h2.54v-1.86c0-2.5 1.5-3.88 3.78-3.88 1.1 0 2.26.2 2.26.2v2.46H14.2c-1.23 0-1.62.77-1.62 1.56v1.86h2.78l-.44 2.9h-2.34v7.03C18.34 21.25 22 17.09 22 12.07z"
                            fill="#1877f2" />
                    </svg>
                </a>
                <a href="#" title="Compartir en X" aria-label="X">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path
                            d="M17.316 3H20.89l-6.843 7.82L22 21h-5.213l-4.08-5.227L8 21H4.425l7.166-8.19L2 3h5.305l3.682 4.725L17.316 3Zm-.91 15.606h1.498L6.464 4.37H4.874L16.406 18.606Z" />
                    </svg>
                </a>
                <a href="#" title="Compartir en WhatsApp" aria-label="WhatsApp">
                    <!-- WhatsApp SVG -->
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path
                            d="M12.04 2a9.93 9.93 0 0 0-8.5 15l-1.4 5.1 5.23-1.37A9.94 9.94 0 1 0 12.04 2Zm0 17.99a8 8 0 0 1-4.27-1.24l-.3-.18-3.09.81.82-2.99-.19-.3a8 8 0 1 1 6.99 3.9Zm4.34-6.01c-.24-.12-1.44-.71-1.66-.79-.22-.08-.38-.12-.54.12s-.62.79-.76.95-.28.18-.52.06a6.6 6.6 0 0 1-3.1-2.7c-.23-.4.23-.37.65-1.24.07-.15.04-.27-.02-.39-.07-.12-.54-1.3-.74-1.78-.19-.46-.38-.4-.54-.41l-.46-.01c-.16 0-.4.06-.61.3-.21.24-.8.78-.8 1.9s.82 2.2.94 2.35c.12.15 1.61 2.45 3.9 3.43 2.29.98 2.29.65 2.7.61.41-.04 1.34-.54 1.53-1.07.19-.54.19-1 .14-1.1-.05-.1-.22-.16-.46-.28Z"
                            fill="#25d366" />
                    </svg>
                </a>
            </div>
        </section>

        <!-- Lista artículos con audio -->
        <ul class="audio-list">

            <li class="audio-item">
                <a href="https://www.de10.com.mx/lo-viral/santiago-gimenez-sale-en-defensa-de-martin-anselmi-la-gente-de-cruz-azul-no-entiende-pero-hubiera-hecho-lo-mismo/"
                    class="thumb" title="The Supreme Court's">
                    <img src="https://www.de10.com.mx/resizer/v2/5JDX2I7A3REVJJNBPHZGLQUZXA.jpg?auth=0ff1ddf8bead4bf3d470186df29ff1bcc35403abadc3d397d0a77f3f16e234cc&smart=true&width=759&height=495"
                        width="48" height="48" alt="Miniatura 1">
                </a>
                <div class="info">
                    <a href="https://www.de10.com.mx/lo-viral/santiago-gimenez-sale-en-defensa-de-martin-anselmi-la-gente-de-cruz-azul-no-entiende-pero-hubiera-hecho-lo-mismo/"
                        class="title">Santiago Giménez sale en defensa de Martín Anselmi: “La gente de Cruz Azul
                        no entiende, pero hubiera hecho lo mismo”</a>
                </div>
                <button class="play" aria-label="Reproducir"></button>
                <audio src="/assets/audios/audio1.mp3"></audio>
            </li>

            <li class="audio-item">
                <a href="https://www.de10.com.mx/tendencias/hugo-sanchez-advierte-a-efrain-juarez-sobre-el-estado-fisico-de-aaron-ramsey-en-pumas/"
                    class="thumb" title="Tech Giants Face Antitrust">
                    <img src="https://www.de10.com.mx/resizer/v2/KFCORKBWL5F25AOMTZDKVD4FWU.jpg?auth=ac8182589fbe4bc91bdd4b7ee711cc99636183d2021a940e454a3219a82ea3ca&smart=true&width=1100&height=666"
                        width="48" height="48" alt="Miniatura 2">
                </a>
                <div class="info">
                    <a href="https://www.de10.com.mx/tendencias/hugo-sanchez-advierte-a-efrain-juarez-sobre-el-estado-fisico-de-aaron-ramsey-en-pumas/"
                        class="title">Hugo Sánchez lanzó advertencia a Efraín Juárez sobre Aaron Ramsey; "Vamos a ver si
                        su físico soporta la intensidad de Pumas"
                    </a>
                </div>
                <button class="play" aria-label="Reproducir"></button>
                <audio src="/assets/audios/audio2.mp3"></audio>
            </li>

            <li class="audio-item">
                <a href="https://www.de10.com.mx/anecdotas-mundialistas/seleccion-mexicana-el-partido-de-sudafrica-2010-donde-el-conejo-perez-corrio-mas-que-el-bofo-bautista/"
                    class="thumb" title="Climate Change Summit">
                    <img src="https://www.de10.com.mx/resizer/v2/2PZ3AZC3VFAKVIWZJ2STV46KWA.jpg?auth=d96dcf1cb7ed2a054f72604a360585fc9a506937d6bc6ebb0aabfff66388cde9&smart=true&width=1100&height=666"
                        width="48" height="48" alt="Miniatura 3">
                </a>
                <div class="info">
                    <a href="https://www.de10.com.mx/anecdotas-mundialistas/seleccion-mexicana-el-partido-de-sudafrica-2010-donde-el-conejo-perez-corrio-mas-que-el-bofo-bautista/"
                        class="title">El partido de Sudáfrica 2010 donde el 'Conejo' Pérez corrió más que el 'Bofo'
                        Bautista</a>
                </div>
                <button class="play" aria-label="Reproducir"></button>
                <audio src="/assets/audios/audio3.mp3"></audio>
            </li>

            <li class="audio-item">
                <a href="https://www.de10.com.mx/seleccion-mexicana/como-le-fue-a-los-seleccionados-nacionales-en-su-regreso-a-la-liga-mx-marcel-ruiz-se-lleva-las-palmas/"
                    class="thumb" title="Global Economic Outlook">
                    <img src="https://www.de10.com.mx/resizer/v2/WKYKOWEHH5BJRH6HM33MMWPNWQ.png?auth=6651c9911ee187969701ddaa66b48cb12530396b3e80a8ba059513714e354481&smart=true&width=1100&height=666"
                        width="48" height="48" alt="Miniatura 4">
                </a>
                <div class="info">
                    <a href="https://www.de10.com.mx/seleccion-mexicana/como-le-fue-a-los-seleccionados-nacionales-en-su-regreso-a-la-liga-mx-marcel-ruiz-se-lleva-las-palmas/"
                        class="title">¿Cómo le fue a los seleccionados nacionales en su regreso a la Liga MX? Marcel
                        Ruíz se lleva las palmas</a>
                </div>
                <button class="play" aria-label="Reproducir"></button>
                <audio src="/assets/audios/audio4.mp3"></audio>
            </li>

            <li class="audio-item">
                <a href="https://www.de10.com.mx/seleccion-mexicana/seleccion-mexicana-las-camisetas-mas-iconicas-de-mexico-en-las-copas-del-mundo/"
                    class="thumb" title="Political Tensions Rise">
                    <img src="https://www.de10.com.mx/resizer/v2/3ON3QVLLTZEUHCD3ZTOBXDJHNA.jpg?auth=e66e67ab2899a4ca9f5125e85b98dd04999f06aea9060eb0af9dae9b936c874c&smart=true&width=1100&height=666"
                        width="48" height="48" alt="Miniatura 5">
                </a>
                <div class="info">
                    <a href="https://www.de10.com.mx/seleccion-mexicana/seleccion-mexicana-las-camisetas-mas-iconicas-de-mexico-en-las-copas-del-mundo/"
                        class="title">Las camisetas más icónicas de la Selección Mexicana en las Copas del Mundo</a>
                </div>
                <button class="play" aria-label="Reproducir"></button>
                <audio src="/assets/audios/audio5.mp3"></audio>
            </li>

        </ul>
    </article>

    <script>
        /* ----------  Reproductor (una pista a la vez)  ---------- */
        const playButtons = document.querySelectorAll('.play');
        const PLAY_SVG = '<svg viewBox="0 0 24 24"><polygon points="6,4 20,12 6,20"/></svg>';
        const PAUSE_SVG = '<svg viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';

        let current = { audio: null, button: null };

        playButtons.forEach(btn => {
            const audio = btn.nextElementSibling;
            btn.innerHTML = PLAY_SVG;

            audio.addEventListener('ended', () => reset(btn, audio));

            btn.addEventListener('click', () => {
                if (current.audio === audio) {
                    audio.pause(); audio.currentTime = 0;
                    reset(btn, audio);
                    return;
                }
                if (current.audio) {
                    current.audio.pause(); current.audio.currentTime = 0;
                    reset(current.button, current.audio);
                }
                audio.play();
                btn.innerHTML = PAUSE_SVG;
                current = { audio, button: btn };
            });
        });

        function reset(btn, audio) {
            if (btn) { btn.innerHTML = PLAY_SVG; }
            if (current.audio === audio) { current = { audio: null, button: null }; }
        }
    </script>

</body>

</html>
`;

export const au_html = `<article class="news-widget">
  <h2>Noticias del Día</h2>
  
  <img class="hero" src="assets/img/anuncion.png" width="300" height="100%" alt="Imagen destacada">
  
  <section class="playlist">
      <h3>Playlist Noticias del día</h3>
      <p>Mantente informado con nuestros audios de las notas del día </p>

      <div class="share">
          <a href="#" title="Compartir en Facebook" aria-label="Facebook">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                      d="M22 12.07C22 6.53 17.52 2 12 2S2 6.53 2 12.07c0 5.02 3.67 9.18 8.44 9.93v-7.03H7.9v-2.9h2.54v-1.86c0-2.5 1.5-3.88 3.78-3.88 1.1 0 2.26.2 2.26.2v2.46H14.2c-1.23 0-1.62.77-1.62 1.56v1.86h2.78l-.44 2.9h-2.34v7.03C18.34 21.25 22 17.09 22 12.07z"
                      fill="#1877f2" />
              </svg>
          </a>
          <a href="#" title="Compartir en X" aria-label="X">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                      d="M17.316 3H20.89l-6.843 7.82L22 21h-5.213l-4.08-5.227L8 21H4.425l7.166-8.19L2 3h5.305l3.682 4.725L17.316 3Zm-.91 15.606h1.498L6.464 4.37H4.874L16.406 18.606Z" />
              </svg>
          </a>
          <a href="#" title="Compartir en WhatsApp" aria-label="WhatsApp">
              <!-- WhatsApp SVG -->
              <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                      d="M12.04 2a9.93 9.93 0 0 0-8.5 15l-1.4 5.1 5.23-1.37A9.94 9.94 0 1 0 12.04 2Zm0 17.99a8 8 0 0 1-4.27-1.24l-.3-.18-3.09.81.82-2.99-.19-.3a8 8 0 1 1 6.99 3.9Zm4.34-6.01c-.24-.12-1.44-.71-1.66-.79-.22-.08-.38-.12-.54.12s-.62.79-.76.95-.28.18-.52.06a6.6 6.6 0 0 1-3.1-2.7c-.23-.4.23-.37.65-1.24.07-.15.04-.27-.02-.39-.07-.12-.54-1.3-.74-1.78-.19-.46-.38-.4-.54-.41l-.46-.01c-.16 0-.4.06-.61.3-.21.24-.8.78-.8 1.9s.82 2.2.94 2.35c.12.15 1.61 2.45 3.9 3.43 2.29.98 2.29.65 2.7.61.41-.04 1.34-.54 1.53-1.07.19-.54.19-1 .14-1.1-.05-.1-.22-.16-.46-.28Z"
                      fill="#25d366" />
              </svg>
          </a>
      </div>
  </section>

  <ul class="audio-list">
      <li class="audio-item">
          <a href="https://www.de10.com.mx/lo-viral/santiago-gimenez-sale-en-defensa-de-martin-anselmi-la-gente-de-cruz-azul-no-entiende-pero-hubiera-hecho-lo-mismo/"
              class="thumb" title="The Supreme Court's">
              <img src="https://www.de10.com.mx/resizer/v2/5JDX2I7A3REVJJNBPHZGLQUZXA.jpg?auth=0ff1ddf8bead4bf3d470186df29ff1bcc35403abadc3d397d0a77f3f16e234cc&smart=true&width=759&height=495"
                  width="48" height="48" alt="Miniatura 1">
          </a>
          <div class="info">
              <a href="https://www.de10.com.mx/lo-viral/santiago-gimenez-sale-en-defensa-de-martin-anselmi-la-gente-de-cruz-azul-no-entiende-pero-hubiera-hecho-lo-mismo/"
                  class="title">Santiago Giménez sale en defensa de Martín Anselmi: “La gente de Cruz Azul
                  no entiende, pero hubiera hecho lo mismo”</a>
          </div>
          <button class="play" aria-label="Reproducir"></button>
          <audio src="/assets/audios/audio1.mp3"></audio>
      </li>

      <li class="audio-item">
          <a href="https://www.de10.com.mx/tendencias/hugo-sanchez-advierte-a-efrain-juarez-sobre-el-estado-fisico-de-aaron-ramsey-en-pumas/"
              class="thumb" title="Tech Giants Face Antitrust">
              <img src="https://www.de10.com.mx/resizer/v2/KFCORKBWL5F25AOMTZDKVD4FWU.jpg?auth=ac8182589fbe4bc91bdd4b7ee711cc99636183d2021a940e454a3219a82ea3ca&smart=true&width=1100&height=666"
                  width="48" height="48" alt="Miniatura 2">
          </a>
          <div class="info">
              <a href="https://www.de10.com.mx/tendencias/hugo-sanchez-advierte-a-efrain-juarez-sobre-el-estado-fisico-de-aaron-ramsey-en-pumas/"
                  class="title">Hugo Sánchez lanzó advertencia a Efraín Juárez sobre Aaron Ramsey; "Vamos a ver si
                  su físico soporta la intensidad de Pumas"
              </a>
          </div>
          <button class="play" aria-label="Reproducir"></button>
          <audio src="/assets/audios/audio2.mp3"></audio>
      </li>

      <li class="audio-item">
          <a href="https://www.de10.com.mx/anecdotas-mundialistas/seleccion-mexicana-el-partido-de-sudafrica-2010-donde-el-conejo-perez-corrio-mas-que-el-bofo-bautista/"
              class="thumb" title="Climate Change Summit">
              <img src="https://www.de10.com.mx/resizer/v2/2PZ3AZC3VFAKVIWZJ2STV46KWA.jpg?auth=d96dcf1cb7ed2a054f72604a360585fc9a506937d6bc6ebb0aabfff66388cde9&smart=true&width=1100&height=666"
                  width="48" height="48" alt="Miniatura 3">
          </a>
          <div class="info">
              <a href="https://www.de10.com.mx/anecdotas-mundialistas/seleccion-mexicana-el-partido-de-sudafrica-2010-donde-el-conejo-perez-corrio-mas-que-el-bofo-bautista/"
                  class="title">El partido de Sudáfrica 2010 donde el 'Conejo' Pérez corrió más que el 'Bofo'
                  Bautista</a>
          </div>
          <button class="play" aria-label="Reproducir"></button>
          <audio src="/assets/audios/audio3.mp3"></audio>
      </li>

      <li class="audio-item">
          <a href="https://www.de10.com.mx/seleccion-mexicana/como-le-fue-a-los-seleccionados-nacionales-en-su-regreso-a-la-liga-mx-marcel-ruiz-se-lleva-las-palmas/"
              class="thumb" title="Global Economic Outlook">
              <img src="https://www.de10.com.mx/resizer/v2/WKYKOWEHH5BJRH6HM33MMWPNWQ.png?auth=6651c9911ee187969701ddaa66b48cb12530396b3e80a8ba059513714e354481&smart=true&width=1100&height=666"
                  width="48" height="48" alt="Miniatura 4">
          </a>
          <div class="info">
              <a href="https://www.de10.com.mx/seleccion-mexicana/como-le-fue-a-los-seleccionados-nacionales-en-su-regreso-a-la-liga-mx-marcel-ruiz-se-lleva-las-palmas/"
                  class="title">¿Cómo le fue a los seleccionados nacionales en su regreso a la Liga MX? Marcel
                  Ruíz se lleva las palmas</a>
          </div>
          <button class="play" aria-label="Reproducir"></button>
          <audio src="/assets/audios/audio4.mp3"></audio>
      </li>

      <li class="audio-item">
          <a href="https://www.de10.com.mx/seleccion-mexicana/seleccion-mexicana-las-camisetas-mas-iconicas-de-mexico-en-las-copas-del-mundo/"
              class="thumb" title="Political Tensions Rise">
              <img src="https://www.de10.com.mx/resizer/v2/3ON3QVLLTZEUHCD3ZTOBXDJHNA.jpg?auth=e66e67ab2899a4ca9f5125e85b98dd04999f06aea9060eb0af9dae9b936c874c&smart=true&width=1100&height=666"
                  width="48" height="48" alt="Miniatura 5">
          </a>
          <div class="info">
              <a href="https://www.de10.com.mx/seleccion-mexicana/seleccion-mexicana-las-camisetas-mas-iconicas-de-mexico-en-las-copas-del-mundo/"
                  class="title">Las camisetas más icónicas de la Selección Mexicana en las Copas del Mundo</a>
          </div>
          <button class="play" aria-label="Reproducir"></button>
          <audio src="/assets/audios/audio5.mp3"></audio>
      </li>

  </ul>
</article>
`;

export const au_css = `@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

*,
*::before,
*::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0
}

body {
    font-family: 'Montserrat', sans-serif;
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    padding: 24px 0;
    color: #111;
}

a {
    color: inherit;
    text-decoration: none
}

.news-widget {
    width: 100%;
    max-width: 300px;
    background: #fff;
    /* fondo blanco fijo */
    overflow: hidden;
    box-shadow: 0 3px 10px rgba(0, 0, 0, .06);
}

.news-widget h2 {
    font-size: 1rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .05em;
    text-align: center;
    padding: 18px 0 14px;
    position: relative;
    color: #000;
}

.news-widget h2::after {
    /* franja naranja bajo el título */
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 300px;
    height: 4px;
    background: #ea552d;
    /* naranja corporativo */
    border-radius: 2px 2px 0 0;
}

@media(max-width:400px) {
    body {
        padding: 24px 10px
    }
}

.hero {
    width: 100%;
    height: fit-content;
    object-fit: cover
}

.playlist {
    background: #eee;
    padding: 16px
}

.playlist h3 {
    font-size: .95rem;
    font-weight: 600;
    margin-bottom: 8px;
    color: #ea552d;
}

.playlist p {
    font-size: .85rem;
    line-height: 1.4;
    color: #555
}

.share {
    display: flex;
    gap: 16px;
    margin-top: 16px;
    justify-content: flex-end;
}

.share a {
    background: #fff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.share svg {
    width: 16px;
    height: 16px
}

.audio-list {
    list-style: none
}

.audio-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 5px 12px 12px;
    border-top: 1px solid #ccc;
}

.audio-item:first-child {
    padding: 12px 5px 12px 12px;
}

.thumb {
    flex: 0 0 48px
}

.thumb img {
    width: 48px;
    height: 48px;
    border-radius: 4px;
    object-fit: cover
}

.info {
    flex: 1;
    min-width: 0
}

.title {
    font-size: .9rem;
    font-weight: 600;
    white-space: break-spaces;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.details {
    font-size: .75rem;
    color: #767676
}

button.play {
    flex: 0 0 34px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0
}

button.play svg {
    width: 20px;
    height: 20px;
    fill: #ea552d
}

button.play:hover svg {
    fill: #ff724b
}

::selection {
    background: #ea552d;
    color: #fff
}
`;
export const au_js = `const playButtons = document.querySelectorAll('.play');
const PLAY_SVG = '<svg viewBox="0 0 24 24"><polygon points="6,4 20,12 6,20"/></svg>';
const PAUSE_SVG = '<svg viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';

let current = { audio: null, button: null };

playButtons.forEach(btn => {
    const audio = btn.nextElementSibling;
    btn.innerHTML = PLAY_SVG;

    audio.addEventListener('ended', () => reset(btn, audio));

    btn.addEventListener('click', () => {
        if (current.audio === audio) {
            audio.pause(); audio.currentTime = 0;
            reset(btn, audio);
            return;
        }
        if (current.audio) {
            current.audio.pause(); current.audio.currentTime = 0;
            reset(current.button, current.audio);
        }
        audio.play();
        btn.innerHTML = PAUSE_SVG;
        current = { audio, button: btn };
    });
});

function reset(btn, audio) {
    if (btn) { btn.innerHTML = PLAY_SVG; }
    if (current.audio === audio) { current = { audio: null, button: null }; }
}
`;